import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectChatState, selectUiState } from '../../../../store/app.selectors';

import { BaseComponent } from '../../../shared/components/base/base.component';
import { uiInitialState } from '../../../shared/store/ui.reducer';
import { setShowStatusBanner } from '../../../shared/store/ui.actions';
import { MessagesService } from '../../services/messages.service';
import { AppStateWithChat, chatInitialState } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-channel-status',
  templateUrl: './channel-status.component.html',
  styleUrls: ['./channel-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChannelStatusComponent extends BaseComponent {
  private store = inject(Store<AppStateWithChat>);
  public messagesService = inject(MessagesService);

  ui = toSignal(this.store.select(selectUiState), { initialValue: uiInitialState });
  chat = toSignal(this.store.select(selectChatState), { initialValue: chatInitialState });

  selectedChannel = computed(() => this.chat().selectedChannel);
  showStatusBanner = computed(() => this.ui().showStatusBanner);

  closeBanner(): void {
    this.store.dispatch(setShowStatusBanner({ value: false }));
  }
}
